import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(private title: Title, private translateService: TranslateService) { }

  ngOnInit(): void {
    this.translateService.get('title_login').subscribe({
      next: (title) => {
        this.title.setTitle(title);
      }
    });
  }

}
